import api from '../services/api';

export function getFutbolModulePublicUrl() {
  return String(
    import.meta.env.VITE_FUTBOL_MODULE_URL || 'http://localhost:3007',
  ).replace(/\/$/, '');
}

export function isFutbolOnlyConsumer(user) {
  if (!user) return false;
  const access = user.module_access || {};
  const licenses = Array.isArray(user.licenses) ? user.licenses : [];
  const active = licenses
    .filter((lic) => lic.active !== false)
    .map((lic) => String(lic.module_code || '').toLowerCase());
  const hasFutbol = access.futbol === true || active.includes('futbol');
  if (!hasFutbol) return false;
  if (active.some((code) => ['d28d', 'gym', 'live_classes', 'training', 'food'].includes(code))) {
    return false;
  }
  if (access.training === true || access.food_plan === true || access.nutrition === true) {
    return false;
  }
  return true;
}

export function resolveFutbolBrandName(user, fallback = 'futbol.app') {
  const branding = user?.futbol_branding || {};
  const tenant = user?.tenant_context || {};
  const cfg = tenant.branding_config || {};
  return String(
    branding.brand_name
    || cfg.organizationName
    || cfg.brand_name
    || tenant.tenant_name
    || fallback,
  ).trim() || fallback;
}

export function futbolDestForUser(user) {
  const role = String(user?.module_access?.futbol_role || '').toUpperCase();
  if (role === 'SCHOOL_ADMIN') return '/admin';
  if (role === 'COACH') return '/coach';
  if (role === 'SPONSOR') return '/sponsor';
  return '/player';
}

/** Evita relanzar SSO en bucle al volver de futbol.app al shell (se limpia al cerrar sesión). */
export function futbolSsoSentThisSession() {
  try { return sessionStorage.getItem('futbol_sso_sent') === '1'; } catch { return false; }
}

export async function openFutbolModule(returnPath = '/dashboard', subPath = '') {
  try {
    const returnUrl = new URL(returnPath, window.location.origin).toString();
    const { data } = await api.get('/futbol-module/launch', {
      params: { return_url: returnUrl, dest: subPath },
    });
    const url = data?.data?.url;
    if (!url) throw new Error('El Shell no entregó una URL de futbol.app');
    window.location.assign(url);
    return { ok: true, mode: 'external', url };
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data?.error || error?.message || 'No se pudo abrir futbol.app',
    };
  }
}
